export default __webpack_public_path__ + "static/media/calendar-mobile.ea691416.png";